Wee.fn.make('programs', {
	init: function() {
		var priv = this.$private;

		priv.total();
		priv.timer();

		Wee.easySlide.init({
			elementRef: 'sliderImage',
			trackerRef: 'sliderImage',
			arrows: 'arrow'
		});

		priv.two = Wee.fn.easySlide();

		Wee.screen.map([
			{
				min: 3,
				callback: function() {
					priv.two.init({
						elementRef: 'relatedSlide',
						trackerRef: 'relatedSlide',
						arrows: 'relatedArrow',
						resizeParent: true
					});
				}
			}
		]);
	}
}, {

	/**
	 * Get total number of images in slider and sets the value
	 *
	 * @private
	 */
	total: function() {
		$('ref:totalImgNum').text($('ref:sliderImage').length);
	},

	/**
	 * Timer that prevents choking the browser when the screen is resized.
	 *
	 * @private
	 */
	timer: function() {
		$(Wee._win).on('resize', function() {
			clearTimeout(this.timer);

			this.timer = setTimeout(this.resize(), 500);
		}.bind(this));
	},

	/**
	 * Checks whether we're on tablet or greater, then
	 * resizes the slider's parent element.
	 *
	 * @private
	 */
	resize: function() {
		if (Wee.screen.size() > 2) {
			this.two.reCalculateParent();
		}
	}
});